import { Component, Input, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { ReportGenSvc, ReportWithDatesRequest, SalesTotalsViewModel } from 'src/app/services_autogenerated/generated_services';
import { RmDateRangeServiceService } from 'src/app/services/rm-date-range-service.service';

@Component({
    selector: 'app-in-backlog',
    templateUrl: './in-backlog.component.html',
    styleUrls: ['./in-backlog.component.css'],
    standalone: false
})
export class InBacklogComponent extends BaseReportCardComponent implements OnInit {
  @Input() mainColor: string = 'rgb(154,118,164)';
  totalsLoading: boolean = true;

  totals: SalesTotalsViewModel;

  constructor(private reportService: ReportGenSvc,
      private rmDashboardDateRangeService: RmDateRangeServiceService) {
    super();
  }

  ngOnInit() {
    var todayMinus1 = new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());

      this.reportService.getBacklogTotals(new ReportWithDatesRequest( {
        id: !this.companyWide ? this.employee.id : null
      })).subscribe(res => {
        this.totals = res;
        this.totalsLoading = false;
      });
  }
}
